import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import LoadingButton from '@mui/lab/LoadingButton'

import OptionsTable, { OptionsTableHandle } from './OptionsTable'
import { useConsultationReasons } from '../model/useConsultationReasons'

export type ConsultationReasonData = {
  id: string
  name: string
}

export type ConsultationReasonsHandle = OptionsTableHandle

export function ConsultationReasons() {
  const { t } = useTranslation()
  const consultationReasons = useConsultationReasons()

  const fields = useMemo(() => [{ id: 'name', isMandatory: true, name: t('field.name.label'), type: 'string' }] as const, [t])

  return (
    <OptionsTable
      ref={consultationReasons.ref}
      data={consultationReasons.data}
      isCreating={consultationReasons.isCreating}
      isDeleting={consultationReasons.isDeleting}
      isListing={consultationReasons.isListing}
      isUpdating={consultationReasons.isUpdating}
      onCreate={consultationReasons.onCreate}
      onDelete={consultationReasons.onDelete}
      onSearch={consultationReasons.onSearch}
      onUpdate={consultationReasons.onUpdate}
      fields={fields}
      name="consultationReason"
      toolbarActions={
        <LoadingButton
          disabled={consultationReasons.isListing}
          loading={consultationReasons.isSeeding}
          onClick={consultationReasons.onSeedDefaults}
          variant="outlined"
        >
          {t('page.superAdmin.settings.seedDefaultReasonsButton.label')}
        </LoadingButton>
      }
    />
  )
}
